import React, { Component } from "react";
import { Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";

const PALETTE = ["#6366f1", "#10b981", "#f59e0b", "#ef4444", "#0ea5e9", "#8b5cf6", "#14b8a6", "#f43f5e"];

class SingleLocation extends Component {
  renderCard(label, value, color, icon, key) {
    return (
      <Col xl={3} md={6} sm={6} key={key}>
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderTop: `4px solid ${color}`, borderRadius: 16, padding: "18px 20px", boxShadow: "0 4px 12px rgba(0,0,0,0.03)", display: "flex", alignItems: "center", gap: 16, marginBottom: 15 }}>
          <div style={{ background: `${color}20`, color, borderRadius: 12, width: 50, height: 50, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <i className={icon} style={{ fontSize: 22 }} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</div>
            <div style={{ fontSize: 21, fontWeight: 800, color: "#1f2937", lineHeight: 1.2 }}>{value}</div>
          </div>
        </div>
      </Col>
    );
  }

  render() {
    const total = this.props.branchData.total_count == null ? "0" : this.props.branchData.total_count;
    return (
      <React.Fragment>
        {this.renderCard("Total Branches", total, "#6366f1", "fal fa-code-branch", "total")}
        {this.props.branchData.branch_data.map((Data, idx) =>
          this.renderCard(Data.region, Data.count, PALETTE[(idx + 1) % PALETTE.length], "fal fa-map-marker-alt", Data.region)
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(SingleLocation);
